<template>
  <div class="marquee-wrap">
    <p v-marquees>
      <span>{{text}}</span>
    </p>
  </div>
</template>

<script>
export default{
	props: {
		text:''
  }
}
</script>
<style lang="scss">
@keyframes textloop {
 0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
  }
 }
.marquee-wrap {
  overflow: hidden;
  p {
    white-space: nowrap;
  }
  p.marquee {
    word-break: keep-all;
    width: fit-content; // NOTE 必须
    animation: textloop linear infinite;
    min-width: 100%;
    span {
      padding-right: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common-components/features/marquee/index.vue